// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"853f4b1a","162":"111c16cc","187":"7e5b79ff","232":"d3532d5a","519":"d99f9a5b","643":"3c697e1e","843":"4f156740","921":"6098c4ad"}[chunkId] + ".chunk.js";
};